import {LOREN_ROUTES} from "../../constants/loren-routes.constants";
import {
    LorenBreakpointObserverService
} from "../../services/loren-breakpoint-observer-service/loren-breakpoint-observer.service";
import {
    LorenNavService
} from "../../modules/loren-nav/components/loren-nav/services/loren-nav-service/loren-nav.service";
import {DestroyRef, Directive, inject} from "@angular/core";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Directive()
export abstract class LorenBaseFeature {
    protected readonly destroyRef = inject(DestroyRef);
    public isHandset: boolean;
    public isMedium: boolean;
    public isLarge: boolean;
    public isExtraLarge: boolean;
    public isCustomXXL: boolean;
    public isTablet: boolean;
    public routes = LOREN_ROUTES;
    protected readonly breakpointObserverService = inject(LorenBreakpointObserverService);
    protected readonly lorenNavService = inject(LorenNavService);

    constructor() {
        this.breakpointObserverService
            .getHandsetStateSubscription()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((res) => (this.isHandset = res));
        this.breakpointObserverService
            .getMediumStateSubscription()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((res) => (this.isMedium = res));
        this.breakpointObserverService
            .getLargeStateSubscription()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((res) => (this.isLarge = res));
        this.breakpointObserverService
            .getTabletStateSubscription()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((res) => (this.isTablet = res));
        this.breakpointObserverService
            .getExtraLargeStateSubscription()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((res) => (this.isExtraLarge = res));
        this.breakpointObserverService
            .getCustomXXLStateSubscription()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((res) => (this.isCustomXXL = res));
    }
}
